





















import { defineComponent } from '@vue/composition-api';
import ElTooltip           from 'element-ui/lib/tooltip';

export default defineComponent({
  name: 'cTooltip',
  components: {
    ElTooltip,
  },
  setup(props, context) {
    const getArrowClass = (): string | null => {
      const { placement }: Record<string, string> = context.attrs;
      if (placement) {
        const position: string = placement.split('-')[ 0 ];
        if (position === 'top' || position === 'bottom') {
          return 'arrow-up-down';
        }
        return null;
      }
      return null;
    };

    const getPaddingClass = (): string | null => {
      const { noPadding }: Record<string, string> = context.attrs;
      if (noPadding) {
        return 'c-tooltip__popup--no-padding';
      }
      return null;
    };

    return {
      getArrowClass,
      getPaddingClass,
    };
  },
});

